app.service('text', function () {

	//sprzatanie tekstu ze znacznikow html
	function clean(text = '') {
		return $.trim(text.replace(/(<([^>]+)>)/g, ''));
	}

	return {
		clean
	}
})